export var HealthStatus;
(function (HealthStatus) {
    HealthStatus["HEALTH_STATUS_UNSPECIFIED"] = "HEALTH_STATUS_UNSPECIFIED";
    HealthStatus["HEALTH_STATUS_OK"] = "HEALTH_STATUS_OK";
    HealthStatus["HEALTH_STATUS_WARN"] = "HEALTH_STATUS_WARN";
    HealthStatus["HEALTH_STATUS_CRIT"] = "HEALTH_STATUS_CRIT";
})(HealthStatus || (HealthStatus = {}));
